import type { RouterConfig } from '@nuxt/schema'
import { parseQuery as vueParseQuery, stringifyQuery as vueStringifyQuery } from 'vue-router'

export default <RouterConfig>{
  scrollBehavior(_to, _from, _savedPosition) {
    return { left: 0, top: 0 }
  },

  // -- 네이버 프리미엄 로그분석 쿼리 파라미터(NaPm) 원본 인코딩값을 그대로 유지위한 처리
  // router에서 들어오는 쿼리도 가공하고, 나가는 쿼리도 가공함. 그래서 둘 다 오버라이드해야 원본값 유지됨

  // 1. NaPm 디코딩 방지
  parseQuery(query) {
    // Vue Router 기본 파싱(다른 파라미터는 기존 동작 그대로)
    const res = vueParseQuery(query) as Record<string, string | string[]>

    // 원본 쿼리 문자열에서 NaPm의 "raw"만 추출
    const m = query.match(/(?:^|[?&])NaPm=([^&#]*)/)
    const rawNaPm = m?.[1]

    if (rawNaPm != null) {
      res.NaPm = rawNaPm // 디코딩 금지
    }

    // 에어브릿지 어트리뷰션 파라미터(airbridge_referrer)도 원본 인코딩값 유지 (디코딩되면 SDK가 채널/캠페인 파싱 불가)
    const am = query.match(/(?:^|[?&])airbridge_referrer=([^&#]*)/)
    const rawAirbridgeReferrer = am?.[1]

    if (rawAirbridgeReferrer != null) {
      res.airbridge_referrer = rawAirbridgeReferrer // 디코딩 금지
    }
    return res
  },

  // 2. NaPm, airbridge_referrer 인코딩 방지 (원본 인코딩값을 그대로 유지)
  stringifyQuery(query) {
    const { NaPm, airbridge_referrer, ...rest } = query
    let result = vueStringifyQuery(rest)

    if (NaPm != null) {
      const naPmValue = Array.isArray(NaPm) ? NaPm[0] : NaPm
      if (naPmValue) {
        result += (result ? '&' : '?') + `NaPm=${naPmValue as string}`
      }
    }

    if (airbridge_referrer != null) {
      const airbridgeReferrerValue = Array.isArray(airbridge_referrer)
        ? airbridge_referrer[0]
        : airbridge_referrer
      if (airbridgeReferrerValue) {
        result += (result ? '&' : '?') + `airbridge_referrer=${airbridgeReferrerValue as string}`
      }
    }

    return result
  }
}
